'use strict';

import BaseService from './base.service';

class CashboxesService extends BaseService {
    /* @ngInject */
    constructor(Cashbox, CashboxTransaction, SegaUser) {
        super(Cashbox, SegaUser);
        this.CashboxTransaction = CashboxTransaction;
    }

    getTransactions(opts) {
        return this.getQueryOpts(opts).then(qOpts => {
            return this.CashboxTransaction.find({
                filter: qOpts
            }).$promise;
        });
    }

    getTransactionsCount(opts) {
        return this.getQueryOpts(opts).then(qOpts => {
            return this.CashboxTransaction.count(qOpts).$promise;
        });
    }

    createAdjustment(opts = {
        id: 0,
        type: '',
        amount: 0,
        comments: ''
    }) {
        return this.Model.createAdjustment(opts).$promise;
    }
}

export default CashboxesService;
